export default "__VITE_ASSET__BGW0V_J7__"